import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { SelectElement } from "../../../components/selectElement2";

export const CrearVideoModal = ({ show, onClose, onSave, ubicaciones }) => {

    const [errors, setErrors] = useState({});
    
    const validateForm = () => {
        const newErrors = {};

        if (!form.ideUbicacion) {
            newErrors.ideUbicacion = 'Debe seleccionar una ubicación';
        }

        if (!form.videoCodigo.trim()) {
            newErrors.videoCodigo = 'Debe ingresar el código del video';
        }

        if (!form.videoTitulo.trim()) {
            console.log("34324234");
            
            newErrors.videoTitulo = 'Debe ingresar el título';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };
    
    const [form, setForm] = useState({
        ideUbicacion: '',
        codigoUbicacion: '',
        videoCodigo: '',
        videoTitulo:''
    });

    const resetForm = () => {
        setForm({
            ideUbicacion: '',
            codigoUbicacion: '',
            videoCodigo: '',
            videoTitulo:''
        });
    };

   
    useEffect(() => {
        if (!show) resetForm();
    }, [show]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        setErrors(prev => ({
            ...prev,
            [name]: ''
        }));
    };

    const handleSubmit = () => {
        
        if (!validateForm()) return;

        onSave({
            ...form,
            videoCodigo: form.videoCodigo.toUpperCase(),
            videoTitulo: form.videoTitulo.toUpperCase(),
        });
    };

    const handleSelectUbicacion = (selected) => {
        setForm(prev => ({
            ...prev,
            ideUbicacion: selected.value,
            codigoUbicacion: selected.data
        }));

        setErrors(prev => ({
            ...prev,
            ideUbicacion: ''
        }));
    };

    return (
        <Modal 
            show={show} 
            onHide={onClose} 
            centered 
            size="lg"
            contentClassName="rounded-4 shadow-lg border-0"
        >
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold fs-4">
                    Crear Video
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form className="row g-3">

                    <Form.Group>
                        <Form.Label>Sede/ubicación</Form.Label>
                        <SelectElement
                            options= { ubicaciones }
                            name={ `idUbicacion`}
                            isMulti= {false}
                            closeOnMenuSelect= {true}
                            value={ubicaciones.find(u => u.value === form.ideUbicacion)}
                            onChange= {(selected) => handleSelectUbicacion(selected)}
                            classname= "form-control form-control-lg" 
                            isClearable = {false}
                        />

                        {errors.ideUbicacion && (
                            <div className="invalid-feedback d-block">
                                {errors.ideUbicacion}
                            </div>
                        )}
    
                    </Form.Group>

                    <Form.Group className="col-md-6">
                        <Form.Label>Código(YOUTube)</Form.Label>
                        <Form.Control
                            name="videoCodigo"
                            value={form.videoCodigo}
                            onChange={handleChange}
                            isInvalid={!!errors.videoCodigo}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.videoCodigo}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="col-md-6">
                        <Form.Label>Título </Form.Label>
                        <Form.Control
                            name="videoTitulo"
                            value={form.videoTitulo}
                            onChange={handleChange}
                            isInvalid={!!errors.videoTitulo}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.videoTitulo}
                        </Form.Control.Feedback>
                    </Form.Group>

                    
                </Form>
            </Modal.Body>

            <Modal.Footer className="border-0">
                <Button variant="light" onClick={onClose}>
                    Cancelar
                </Button>

                <Button variant="primary" onClick={handleSubmit}>
                    Guardar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};